/**
 * Node Modules
 */
import React from 'react'
import { Helmet } from 'react-helmet'
import { Link, graphql } from 'gatsby'

/**
 * Application Modules
 */
import PageContainer from '../../components/page-container'
import Metadata from '../../components/metadata'
import Footer from '../../components/footer'

import Hero from '../../sections/about/hero'
import OurStory from '../../sections/about/our-story'
import LifeAtKinzoo from '../../sections/about/life-at-kinzoo'
import DownloadBanner from '../../components/download-banner'

import './styles.css'
// import ContactForm from '../../components/contact-form'

/**
 * Page Component
 */
export default function Page({ data }) {
  const {
    referencePageMetadata,
    heroDek,
    heroHed,
    lifeAtKinzooDek,
    lifeAtKinzooHed,
    ourStoryDek,
    ourStoryHed,
    locationHed,
    locationDek,
  } = data.contentfulSingletonAboutUs

  return (
    <PageContainer>
      <Helmet>
        <link rel="canonical" href="https://kinzoo.com/about/" />
        <meta property="og:url" content="https://kinzoo.com/about/" />
      </Helmet>
      <Metadata {...referencePageMetadata} />
      <Hero hed={heroHed} dek={heroDek.heroDek} />
      <OurStory hed={ourStoryHed} dek={ourStoryDek.ourStoryDek} />
      <LifeAtKinzoo hed={lifeAtKinzooHed} dek={lifeAtKinzooDek.lifeAtKinzooDek} />
      <section className="clearfix about-team flex flex-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 80" className="about-team__curve">
          <g fill="none" fillRule="evenodd" transform="translate(0 -2079) translate(-1 2079)">
            <path
              fill="#FFF"
              d="M1282 0l.009 7.646C1096.39 53.653 880.66 80 650.5 80 412.858 80 190.6 51.913.987 3.098L1 0h1281z"
            ></path>
          </g>
        </svg>
        <img src="/team-photo.jpg" className="about-team__photo" alt="Photo of the Kinzoo team" />
        <div className="about-team__copy flex flex-center">
          <h3 className="about-team__hed ">{locationHed}</h3>
          <p className="about-team__dek ">{locationDek.locationDek}</p>

          <Link
            to="/life-at-kinzoo"
            className="reset button button--f4 button--yellow"
            to="/life-at-kinzoo"
          >
            Life at Kinzoo
          </Link>
        </div>
      </section>
      {/* <ContactForm/> */}
      <DownloadBanner />
      <Footer />
    </PageContainer>
  )
}

export const pageQuery = graphql`
  query AboutPageQuery {
    contentfulSingletonAboutUs(contentful_id: { eq: "2LLDWGSydsW5AEzjMBMFHd" }) {
      referencePageMetadata {
        pageTitle
        ogTitle
        twitterTitle
        description
        ogDescription
        twitterDescription
        ogImage {
          file {
            url
          }
        }
        twitterImage {
          file {
            url
          }
        }
      }

      advisorQuote {
        name
        quote
        brand
        image
      }
      heroDek {
        heroDek
      }
      heroHed
      lifeAtKinzooDek {
        lifeAtKinzooDek
      }
      lifeAtKinzooHed
      ourStoryDek {
        ourStoryDek
      }
      ourStoryHed
      locationHed
      locationDek {
        locationDek
      }
    }
  }
`
